import { render, staticRenderFns } from "./whitelabel.vue?vue&type=template&id=f0245556"
import script from "./whitelabel.vue?vue&type=script&lang=js"
export * from "./whitelabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AuthJoinOrLoginForm: require('/usr/src/app/components/auth/join-or-login-form.vue').default,ModalBasic: require('/usr/src/app/components/modal/basic.vue').default})
